<div class="content">
    <strong class="title">
        Tenant {{username}}
    </strong>
</div>
